import {
  CLOZE_TEXT,
  MULTIPLE_CHOICE,
  MULTIPLE_SELECTION,
  SHORT_TEXT,
  TRUE_OR_FALSE,
} from '@edulastic/constants/const/questionType'
import { titleToAIQuestionType } from './form'

export const copyContentToClipboard = (content) => {
  const el = document.createElement('textarea')
  el.value = content
  document.body.appendChild(el)
  el.select()
  document.execCommand('copy')
  document.body.removeChild(el)
}

export const getQuestionDisplayContent = ({ stimulus, questionType }) => {
  if (stimulus) {
    if (questionType === CLOZE_TEXT) {
      return stimulus.replaceAll(
        /(<textinput.*?><\/textinput>|\{\{blank[\w-]*}}|_{2,})/g,
        '_____'
      )
    }
    return stimulus
  }
  return stimulus
}

export const transformPAQuestionToAIQuestion = (question) => {
  const {
    stimulus = '',
    validation: { validResponse: { value: correcAnswerUUIDs = [] } = {} } = {},
    title,
  } = question || {}

  const questionType = titleToAIQuestionType(title)
  let correctAnswerObj = {}
  let { options = [] } = question || {}

  if (questionType === MULTIPLE_CHOICE) {
    correctAnswerObj = {
      correctAnswerIndex: options.findIndex(({ value }) =>
        correcAnswerUUIDs.includes(value)
      ),
    }
  } else if (questionType === MULTIPLE_SELECTION) {
    correctAnswerObj = {
      correctAnswersIndex: options
        .map(({ value }, index) =>
          correcAnswerUUIDs.includes(value) ? index : -1
        )
        .filter((index) => index > -1),
    }
  } else if (questionType === TRUE_OR_FALSE) {
    const correctAnswerIndex = options.findIndex(({ value }) =>
      correcAnswerUUIDs.includes(value)
    )
    correctAnswerObj = {
      correctAnswer: options[correctAnswerIndex].label === 'True',
    }
  } else if (questionType === SHORT_TEXT) {
    options = [
      {
        label: question.validation.validResponse?.value,
      },
    ]
  } else if (questionType === CLOZE_TEXT) {
    options = (question.validation.validResponse?.value || []).map(
      ({ value }) => ({
        label: value,
      })
    )
  }

  return {
    name: stimulus,
    options: options.map(({ label }) => ({ name: label })),
    ...correctAnswerObj,
  }
}

export const getAIEnhanceExistingQuestionPayloadData = ({
  question,
  questionType,
}) => {
  const transformedAIQuestion = transformPAQuestionToAIQuestion(question)
  transformedAIQuestion.name =
    getQuestionDisplayContent({
      stimulus: transformedAIQuestion.name,
      questionType,
    }) || transformedAIQuestion.name

  if (questionType === TRUE_OR_FALSE) {
    delete transformedAIQuestion.options
    return transformedAIQuestion
  }
  return transformedAIQuestion
}
